export default __webpack_public_path__ + "static/promo4-deb95a3d21f9c424b62ab001b97822d9.mp4";